<template>
    <div>
        <div id="main_wrap" class="login_wrap">
            <div class="login_bg_slider_wrap">
                <div class="main_banner_slider" v-if="banner">
                    <div class="main_banner_slider_inner" :style="{'background-image': 'url('+banner?.background_file+')'}">
                        
                    </div>
                </div>
            </div>
            <div class="top_logo">
                <a :href="siteUrl" target="_blank"><img src="assets/media/images/logo.png" alt=""></a>
            </div>
            <div class="signup_content_wrap">
                <div class="signup_inner_content">
                    <section class="login_container">
                        <section class="wrapper signup_wrapper">
                            <header>
                                <div class="logo">
                                    <span>
                                        <a :href="siteUrl" target="_blank">
                                            <img src="assets/media/images/logo.png" alt="">
                                        </a>
                                    </span>
                                </div>
                                <h1>User Registration</h1>
                            </header>
                            <section class="main-content">
                                <form @submit.prevent="login">
                                    <div class="row">
                                        <div class="col-md-6 mb-3">
                                            <label for="first_name" class="form-label">First Name</label>
                                            <input id="first_name" type="text" class="form-control" placeholder="Enter first name." v-model="form.first_name" />
                                            <v-errors :errors="errorFor('first_name')"></v-errors>
                                        </div>
                                        <div class="col-md-6 mb-3">
                                            <label for="last_name" class="form-label">Last Name</label>
                                            <input id="last_name" type="text" class="form-control" placeholder="Enter last name." v-model="form.last_name" />
                                            <v-errors :errors="errorFor('last_name')"></v-errors>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12 mb-3">
                                            <label for="email" class="form-label">Email</label>
                                            <input id="email" type="email" class="form-control" v-model="form.email" placeholder="Enter unique valid email address." />
                                            <v-errors :errors="errorFor('email')"></v-errors>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-md-6">
                                            <label for="password" class="form-label">Password</label>
                                            <input id="password" type="password" class="form-control" v-model="form.password" placeholder="Enter mixed character (aA1@$!%*?#) of 8 digits." />
                                            <v-errors :errors="errorFor('password')"></v-errors>
                                        </div>
                                        <div class="col-md-6">
                                            <label for="password_confirmation" class="form-label">Confirm Password</label>
                                            <input id="password_confirmation" type="password" v-model="form.password_confirmation" class="form-control" placeholder="Enter same as password." />
                                            <v-errors :errors="errorFor('password_confirmation')"></v-errors>
                                        </div>
                                    </div>
                                    <div class="row mb-3">
                                        <div class="col-md-6">
                                            <label for="company_name" class="form-label">Company Name</label>
                                            <input id="company_name" type="text" v-model="form.company_name" class="form-control" placeholder="Enter company name." />
                                            <v-errors :errors="errorFor('company_name')"></v-errors>
                                        </div>
                                        <div class="col-md-6">
                                            <label for="phone" class="form-label">Phone Number</label>
                                            <input id="phone" type="text" v-model="form.phone" class="form-control" placeholder="Enter phone number." />
                                            <v-errors :errors="errorFor('phone')"></v-errors>
                                        </div>
                                    </div>
                                    <div class="d_flex_center ">
                                        <button type="submit" class="common_btn tt_uppercase width_full" @click.prevent="register" :disabled="loading">Sign Up</button>
                                    </div>
                                    <div class="d_flex_center">
                                        <button type="button" class="transparent_btn_type_2 button_text_alter tt_uppercase width_full">
                                           <router-link :to="{name : 'login'}" >
                                                <span class="default">Have an account? please login</span>
                                            </router-link>
                                        </button>
                                    </div>
                                </form>
                            </section>
                        </section>
                    </section>
                </div>
            </div>
        </div>
        <div class="chatbot_wrap">
            <div class="chatbot_icon" @click="openChatBox">
                <svg width="50" height="50" viewBox="0 0 50 50" fill="none">
                    <rect width="36.7813" height="30.888" rx="7" fill="#F3F3F3"/>
                    <path d="M6.13281 30.2148H17.627L8.66437 37.9172C8.35971 38.179 7.9713 38.323 7.56958 38.323V38.323V38.323C6.76096 38.2686 6.13281 37.5969 6.13281 36.7864V30.2148Z" fill="#F3F3F3"/>
                    <ellipse cx="9.05254" cy="16.1069" rx="3.20879" ry="3.04054" fill="#B0B0B0"/>
                    <ellipse cx="18.1463" cy="16.2046" rx="3.20879" ry="3.04054" fill="#B0B0B0"/>
                    <ellipse cx="27.2478" cy="16.1069" rx="3.20879" ry="3.04054" fill="#B0B0B0"/>
                    <path d="M42.1875 43.1406H33.5938L40.3 49.106C40.524 49.3053 40.8134 49.4154 41.1133 49.4154V49.4154V49.4154C41.7182 49.3733 42.1875 48.8703 42.1875 48.2639V43.1406Z" fill="#B0B0B0"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.1875 33.7299V36.142C17.1875 40.008 20.3215 43.142 24.1875 43.142H41.4373C45.3032 43.142 48.4373 40.008 48.4373 36.142V25.043C48.4373 21.177 45.3032 18.043 41.4373 18.043H39.062V26.7299C39.062 30.5958 35.928 33.7299 32.062 33.7299H17.1875Z" fill="#B0B0B0"/>
                </svg>
            </div>
            <div class="chatbot_box_wrap chatbot_box_wrap_no_login" :class="{open: isOpenChat}">
                <div class="without_login_popup">
                    <h4>Want To Start Chat</h4>
                    <div class="d_flex_center">
                        <router-link :to="{name : 'login'}" class="btn btn-sm btn-primary">Please Login</router-link>
                    </div>
                </div>
            </div>
        </div>
        <alert-modal 
            v-if="showAlertModal"
            :show="showAlertModal"
            :title="'Success'"
            :details="alertMessage"
            @closeModal="closeModal"
        />
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import validationErrors from "@/mixins/validationErrors";
import AlertModal from './AlertModal.vue';
export default {
    mixins: [validationErrors],
    computed: {
        ...mapGetters({
            appName: 'getAppName'
        })
    },
    components: {AlertModal},
    data() {
        return {
            siteUrl: process.env.VUE_APP_SITE_URL,
            form: {
                first_name: '',
                last_name: '',
                email: '',
                password: '',
                password_confirmation: '',
                company_name: '',
                phone: '',
            },
            banner: null,
            isOpenChat: false,
            loading: false,
            showAlertModal: false,
            alertMessage: '',
        }
    },
    mounted() {
        this.fetchBanners()
    },
    beforeUnmount () {
        
    },
    methods: {
        register() {
            this.loading = true
            this.allErrors = null;
            this.axios.post('/register', this.form)
            .then((response) => {
                if(response.data.success){
                    this.allErrors = null;
                    if(response.data.console_requested){
                        this.alertMessage = response.data.message;
                        this.showAlertModal = true
                    }else{
                        this.alertMessage = "'Please verify your email and wait 1-2 business days for verification from our admin'";
                        this.showAlertModal = true
                    }
                    
                }else{
                    this.showFailMsg(response.data.message);
                }
                
            })
            .catch((err) => {
                this.allErrors = err.response.data.errors
                this.showFailMsg(err.response.data.message);
            })
            .finally(() => this.loading = false);
        },
        closeModal (){
            this.showAlertModal = false
            this.$router.push('/login')
        },
        fetchBanners() {
            this.axios.get('/get-banners')
            .then(({ data }) => {
                this.banner = data.data;
            })
        },
        openChatBox() {
            this.isOpenChat = !this.isOpenChat
        },
    }
}
</script>
<style scoped>
 .resend_link{
    cursor: pointer;
    text-decoration: none;
    color: #6065D9;
    float: right;
 }
</style>